<header class="app-header">
  <nav class="app-header__nav" aria-label="Main">
    <div class="app-header__left">
      <button type="button" class="app-header__icon-btn app-header__menu-btn" (click)="onMenuClick()"
        aria-label="Toggle modules menu">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>

      <a class="app-header__brand">
        <img src="assets/image/sri_logo.png" alt="SCAITS logo" class="app-header__logo" />
        <!-- <span class="app-header__brand-name">SCAITS</span> -->
      </a>

      <!-- <div class="app-header__links d-none d-lg-flex">
        <button type="button" class="app-header__link" routerLink="/dashboard" (click)="dashboard()"
          routerLinkActive="is-active">Dashboard</button>
        <button type="button" class="app-header__link" routerLink="/totaldvr" (click)="dvrstatus()"
          routerLinkActive="is-active">DVR/NVR Status</button>
        <button mat-button [matMenuTriggerFor]="theMenu" class="app-header__link app-header__link--mat">DVR</button>
        <mat-menu #theMenu="matMenu">
          <button mat-menu-item routerLink="/dvr/add-dvr" (click)="adddvr()">Add DVR</button>
        </mat-menu>
      </div> -->
    </div>

    <div class="app-header__right">
      <button
        type="button"
        class="app-header__icon-btn"
        (click)="toggleFullscreen()"
        [attr.aria-label]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
        [title]="isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
      >
        <i class="fa" [class.fa-expand]="!isFullscreen" [class.fa-compress]="isFullscreen" aria-hidden="true"></i>
      </button>

      <!-- <button
        type="button"
        class="app-header__icon-btn"
        (click)="toggleTheme()"
        [attr.aria-label]="resolvedTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
        [title]="resolvedTheme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
      >
        <i
          class="fa"
          [class.fa-sun]="resolvedTheme === 'light'"
          [class.fa-moon]="resolvedTheme === 'dark'"
          aria-hidden="true"
        ></i>
      </button> -->

      <div class="dropdown">
        <button class="app-header__icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"
          aria-label="User menu">
          <!-- <i class="fa fa-user" aria-hidden="true"></i> -->
          <img src="../../../../assets/image/grievance/user-icon 1.svg" alt="User Avatar" class="avatar" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li><span class="dropdown-item-text">User: {{ retrievedData }}</span></li>
          <li><span class="dropdown-item-text">Campus: {{ retrievedData1 }}</span></li>
          <li><button class="button-out" (click)=" Logout()">Log out</button></li>
        </ul>
      </div>

      <!-- <div class="dropdown">
        <a class="btn user"  data-bs-toggle="dropdown" aria-expanded="false">
             <img src="../../../../assets/image/grievance/user-icon 1.svg" alt="User Avatar" class="avatar" />
        </a>
        <ul class="dropdown-menu user_details dropdown-left" (click)="$event.stopPropagation()">
          <li><a class="dropdown-item user_name">User Name : {{ retrievedData }}</a></li>
            <li><a class="dropdown-item campus_name">Campus Name : {{campusName}}</a></li>
          <li><button class="button" (click)="logOut()">Log out</button></li>
        </ul>
      </div> -->

      <!-- <button type="button" class="app-header__home-btn" (click)="Logout()">HOME</button> -->
    </div>
  </nav>
</header>
